import { useEffect, useRef } from "react"
import { useAnimationControls } from "framer-motion"
import { haptic } from "../utils/haptics.utils"

// Quanto tenere premuto perché il tocco diventi un'altra cosa
export const HOLD_DELAY = 450
// prima di questo il riempimento non parte: un tocco normale non deve
// far vedere niente
const FILL_DELAY = 120

// Un bottone che fa una cosa al tocco e un'altra tenuto premuto: le frecce
// della barra (un giorno, una settimana) e il "+" (una lezione, quando
// giochi tu).
//
// La vibrazione su iPhone non esiste: quello che dice "stai tenendo
// premuto" è un riempimento che sale da sotto, e `fill` sono i suoi
// controlli. Senza `onHold` il bottone fa solo il tocco.
//
// Il tocco si decide al clic, che arriva anche da tastiera: se nel
// frattempo la pressione lunga è già scattata, il clic che la chiude non
// conta.
const useHoldPress = ({ onTap, onHold }) => {
	const fill = useAnimationControls()
	const timer = useRef(null)
	const firedHold = useRef(false)

	const reset = () => {
		clearTimeout(timer.current)
		timer.current = null
		fill.stop()
		fill.set({ scaleY: 0 })
	}

	useEffect(() => () => clearTimeout(timer.current), [])

	const onPointerDown = event => {
		// anche se l'ultima pressione non ha chiuso con un clic (su iPhone a
		// volte non arriva), il tocco nuovo riparte pulito
		firedHold.current = false
		if (!onHold || event.button > 0) return
		fill.start({
			scaleY: 1,
			transition: {
				delay: FILL_DELAY / 1000,
				duration: (HOLD_DELAY - FILL_DELAY) / 1000,
				ease: "linear",
			},
		})
		timer.current = setTimeout(() => {
			firedHold.current = true
			timer.current = null
			fill.set({ scaleY: 0 })
			// dove c'è, due tick; dove non c'è basta il bottone
			haptic("jump")
			onHold()
		}, HOLD_DELAY)
	}

	const onClick = () => {
		if (firedHold.current) {
			firedHold.current = false
			return
		}
		reset()
		onTap()
	}

	return {
		fill,
		handlers: {
			onPointerDown,
			onPointerUp: () => timer.current && reset(),
			onPointerLeave: reset,
			onPointerCancel: reset,
			onContextMenu: event => onHold && event.preventDefault(),
			onClick,
		},
		// su iPhone una pressione lunga apre il menu del link e seleziona il
		// testo: qui è un gesto dell'app
		style: {
			overflow: "hidden",
			WebkitTouchCallout: "none",
			userSelect: "none",
			WebkitUserSelect: "none",
			touchAction: "manipulation",
		},
	}
}

export default useHoldPress
